import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import posts from '../../Data/BlogPosts.json'; // Import blog data
import styles from './BlogPost.module.css'; // Import module-specific styles
import MainLayout from '../../Layout/MainLayout';

const BlogPost = () => {

    // Get the post ID from the URL parameters
    const { id } = useParams();
    const postIndex = parseInt(id);
    const post = posts[postIndex];

    // Scroll to the top of the page when the component mounts or `id` changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    // Check if the post exists
    if (!post) {
        return <div>Post not found</div>;
    }

    // Function to get the next 3 posts to display at the bottom of page
    const getNextPosts = () => {
        const nextPosts = [];
        for (let i = 1; i <= 3; i++) {
            const nextIndex = (postIndex + i) % posts.length;
            if (nextIndex === postIndex) break; // Prevent repeating the current post
            nextPosts.push({ ...posts[nextIndex], originalIndex: nextIndex });
        }
        return nextPosts;
    };

    const nextPosts = getNextPosts();

    return (
        <MainLayout> {/* Wrapper component for main layout structure */}
            <div className={styles.blogP}>
                {/* Blog post title, author, date, and image at the top */}
                <div className={styles.blogP1}>
                    <h2>{post.title}</h2>
                    <span>{`${post.author} | ${post.date}`}</span>
                    <img src={post.image} alt={post.title} />
                </div>
                {/* Blog post content */}
                <div className={styles.blogP2}>
                    <h2>{post.bigheadline}</h2>
                    <p>{post.text1}</p>
                    <p>{post.text2}</p>
                    <h3>{post.smallheadline}</h3>
                    <p>{post.text3}</p>
                    <div className={styles.blogP2Part}>
                        <div className={styles.blogP2Line}>.</div>
                        <p className="pLarge">{post.text4}</p>
                    </div>
                    <p>{post.text5}</p>
                </div>
                {/* Blog post bottom section, suggesting other blog posts */}
                <div className={styles.blogP3}>
                    <h1>Read more posts</h1>
                    <div className={styles.blogPostContainer}>
                        {nextPosts.map((nextPost, index) => (
                            <Link to={`/blog/${nextPost.originalIndex}`} key={index} className={styles.blogPost}>
                                <img src={nextPost.image} alt={nextPost.title} />
                                <h4>{nextPost.title}</h4>
                                <p>{nextPost.description}</p>
                                <span>{`${nextPost.author} | ${nextPost.date}`}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}

export default BlogPost;